import { AdminPromotionDto } from 'services/data-contracts';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Text from 'components/commons/Text';
import { Row } from 'saladsoft-primitive';
import { Switch } from '@mui/material';
import { FormControlLabel } from '@mui/material';

function stripHTML(html: string): string {
  return html
    .replace(/<[^>]*>/g, '') // HTML 태그 제거
    .replace(/&nbsp;/g, ' ') // &nbsp; 를 일반 공백으로 변환
    .replace(/&[a-z0-9]+;/gi, ''); // 다른 HTML 엔티티 제거
}

const PromotionsCard = ({
  promotion,
  onClick,
  onChangeIsActive,
}: {
  promotion: AdminPromotionDto;
  onClick: () => void;
  onChangeIsActive: (isActive: boolean) => void;
}) => {
  const [isActive, setIsActive] = useState(promotion?.isActive);
  const handleChangeIsActive = (isActive: boolean) => {
    setIsActive(isActive);
    onChangeIsActive(isActive);
  };

  useEffect(() => {
    setIsActive(promotion?.isActive);
  }, [promotion]);

  return (
    <CardWrapper>
      <ImageWrapper>
        <img src={promotion?.images?.[0]?.url} />
      </ImageWrapper>
      <div style={{ flex: 1, minWidth: 0, height: '100%' }}>
        <Row
          flexDirection="column"
          justifyContent="space-between"
          alignItems="flex-start"
          padding="10px"
          height={'100%'}
          flex={1}
        >
          <div style={{ minWidth: 0, width: '100%' }}>
            <Row width="100%" justifyContent="flex-start" gap={20}>
              <div style={{ cursor: 'pointer' }} onClick={onClick}>
                <Text style={{ fontSize: 20, fontWeight: 600 }}>
                  {promotion?.localizedTitle?.ko}
                </Text>
              </div>
              <FormControlLabel
                control={
                  <Switch
                    size="medium"
                    checked={isActive}
                    onChange={(e) => {
                      handleChangeIsActive(e.target.checked);
                    }}
                  />
                }
                label=""
              />
            </Row>
            <ResponsiveDesc>
              {stripHTML(promotion?.localizedDesc?.ko || '')}
            </ResponsiveDesc>
          </div>
          <div style={{ width: '100%', minWidth: 0 }}>
            <InlineClamp>
              <Text style={{ fontSize: 14, fontWeight: 400, color: '#8E8E8E' }}>
                {promotion?.localizedPeriod?.ko}
              </Text>
            </InlineClamp>
            <InlineClamp>
              <Text style={{ fontSize: 14, fontWeight: 400, color: '#8E8E8E' }}>
                {promotion?.localizedAddress?.ko}
              </Text>
            </InlineClamp>
          </div>
        </Row>
      </div>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  height: 100%;
  height: 180px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  overflow: hidden;
  min-width: 0;
`;

const ImageWrapper = styled.div`
  width: 250px;
  height: 180px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  border-radius: 10px;
  > img {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

// 설명: 화면 크기에 따라 3/2/1줄로 보이도록 조절
const ResponsiveDesc = styled.div`
  font-size: 14px;
  font-weight: 400;
  padding-top: 20px;
  color: #555;
  width: 100%;
  min-width: 0;
  overflow: hidden;

  @media (min-width: 1200px) {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  @media (max-width: 767px) {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;

// 한 줄 또는 두 줄로 반응형 클램프(주소/기간 라인에 사용)
const InlineClamp = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;

  // Text 컴포넌트가 내부에 div를 렌더링하므로 직접 타겟팅
  > div {
    width: 100%;
    min-width: 0;
    overflow: hidden;
  }

  // 데스크톱: 두 줄 표시
  @media (min-width: 1200px) {
    > div {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }

  // 태블릿: 한 줄 말줄임
  @media (min-width: 768px) and (max-width: 1199px) {
    > div {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  // 모바일: 한 줄 말줄임
  @media (max-width: 767px) {
    > div {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export default PromotionsCard;
